"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
class Parse {
    static ethereumAmount(total) {
        if (!total.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        // cut leading zeros
        const quantity = total.replace(/^0*/, "") || "0";
        const fractionalDigits = constants_1.constants.primaryTokenFractionalDigits;
        return {
            quantity: quantity,
            fractionalDigits: fractionalDigits,
            tokenTicker: constants_1.constants.primaryTokenTicker,
        };
    }
    static transactionId(hash) {
        if (!hash.match(/^0x[0-9a-f]{64}$/)) {
            throw new Error("Invalid transaction ID format");
        }
        return hash;
    }
}
exports.Parse = Parse;
//# sourceMappingURL=parse.js.map